/**
 * @generated SignedSource<<c1f1054d5b57c5fe311cbd2fb0491f83>>
 * @relayHash cf46500e5ef8801e12ac4119c6e05ce8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2528937add04ac74e13a72d4bcaa197256a2ccc74bf58aabab8b47a480a7e9dc

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraHomePageQuery$variables = {
  cloudId: string;
};
export type JiraHomePageQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HomeTopSection_query" | "JiraHome_query">;
};
export type JiraHomePageQuery = {
  response: JiraHomePageQuery$data;
  variables: JiraHomePageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "JiraHomePageQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "kind": "FragmentSpread",
        "name": "JiraHome_query"
      },
      {
        "args": (v2/*: any*/),
        "kind": "FragmentSpread",
        "name": "HomeTopSection_query"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "JiraHomePageQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "ScalarField",
            "name": "isUserActiveInAnySpace"
          }
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              (v1/*: any*/),
              {
                "kind": "Literal",
                "name": "first",
                "value": 4
              }
            ],
            "concreteType": "JiraSpaceSearchForYouConnection",
            "kind": "LinkedField",
            "name": "spaceSearchForYou",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraSpaceSearchForYouError",
                "kind": "LinkedField",
                "name": "error",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "statusCode"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "errorType"
                  }
                ]
              },
              {
                "concreteType": "JiraSpaceSearchForYouEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "key"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "projectType"
                      },
                      {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "large"
                          }
                        ]
                      },
                      {
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 7
                          },
                          {
                            "kind": "Literal",
                            "name": "recommend",
                            "value": true
                          }
                        ],
                        "concreteType": "JiraAssignableUsersConnection",
                        "kind": "LinkedField",
                        "name": "assignableUsers",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "totalCount"
                          },
                          {
                            "concreteType": "JiraAssignableUsersEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "accountId"
                                  },
                                  (v3/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "picture"
                                  },
                                  (v4/*: any*/)
                                ]
                              }
                            ]
                          }
                        ],
                        "storageKey": "assignableUsers(first:7,recommend:true)"
                      },
                      (v4/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "recommendationType"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "2528937add04ac74e13a72d4bcaa197256a2ccc74bf58aabab8b47a480a7e9dc",
    "metadata": {},
    "name": "JiraHomePageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "3e8fe5628b79bab7a6101fd20155d691";

export default node;
